import React, { createContext, useContext, useState } from 'react';
import { noop } from 'lodash';
import { FEATURE_FLAGS } from './feature-flag.constants';
import { getConfig } from '../../global-discover-config';

export type FeatureFlagType = {
  featureFlags: { [key: string]: boolean };
  updateFlag: (key: string, val: boolean) => void;
};

export const FeatureFlagContext = createContext<FeatureFlagType>({
  featureFlags: {},
  updateFlag: noop,
});

const getInitialFeatureFlags = () => {
  const {
    featureFlags: {
      [FEATURE_FLAGS.VIZ_QUERY_WATCH]: VIZ_QUERY_WATCH = false,
    } = {},
  } = getConfig() ?? {};

  return {
    [FEATURE_FLAGS.VIZ_QUERY_WATCH]: VIZ_QUERY_WATCH,
  };
};

export const FeatureFlagProvider = ({ children }) => {
  const [featureFlags, setFeatureFlags] = useState(getInitialFeatureFlags());

  const updateFlag = (flag, value) => {
    setFeatureFlags(prev => ({
      ...prev,
      [flag]: value,
    }));
  };
  return (
    <FeatureFlagContext value={{ featureFlags, updateFlag }}>
      {children}
    </FeatureFlagContext>
  );
};

export const useFeatureFlagProvider = () => useContext(FeatureFlagContext);
